import { IFoodDiscount, IFoodDiscountCreate, IFoodDiscountUpdate } from "../models/IFoodDiscount";
import { configWithUserToken } from "./config";

export const createFoodDiscount = (data: IFoodDiscountCreate) =>
  configWithUserToken.post<IFoodDiscount>("FoodDiscount", data);

export const updateFoodDiscount = (foodDiscountId: string, data: IFoodDiscountUpdate) =>
  configWithUserToken.put<IFoodDiscount>(`FoodDiscount/${foodDiscountId}`, data);

export const getFoodDiscountById = (foodDiscountId: string) =>
  configWithUserToken.get<IFoodDiscount>(`FoodDiscount/${foodDiscountId}`);

export const getFoodDiscountsByFoodId = (foodId: string) =>
  configWithUserToken.get<IFoodDiscount[]>(`FoodDiscount/food/${foodId}`);

export const getFoodDiscountsByRestaurant = (
  restourantId: string,
  onlyInEffect = false,
  pageIndex = 0,
  pageSize = 20
) =>
  configWithUserToken.get<IFoodDiscount[]>(
    `FoodDiscount/restourant/${restourantId}?onlyInEffect=${onlyInEffect}&pageIndex=${pageIndex}&pageSize=${pageSize}`
  );

export const deleteFoodDiscount = (foodDiscountId: string) =>
  configWithUserToken.delete(`FoodDiscount/${foodDiscountId}`);

export const toggleFoodDiscountActive = (foodDiscountId: string) =>
  configWithUserToken.patch<IFoodDiscount>(`FoodDiscount/${foodDiscountId}/toggle`);
